import { useActivePageId, usePage, useUpdatePage, useUpdatePageProducts } from "../../../data";
import { COLUMN_TYPE_OPTIONS, DEFAULT_MAIN_COLUMN_TYPE } from "@package/grid-utils";
import { fitMainMonthColumnToType } from "../columns/fitMainMonthColumnWidth";
import type { GetContextMenuSection } from "./helpers";
import { getIcon } from "./icons";

export const useGetMenuItemsColumnType = (): GetContextMenuSection => {
  const update = useUpdatePageProducts();
  const updatePage = useUpdatePage();
  const pageId = useActivePageId();
  const page = usePage(pageId);

  return (ctx) => {
    if (ctx.headerParams?.mainMonth) {
      const current = page.data?.main_column_type ?? DEFAULT_MAIN_COLUMN_TYPE;
      return [
        {
          name: "Column type",
          icon: getIcon("type"),
          subMenu: COLUMN_TYPE_OPTIONS.map((type) => ({
            name: type.label,
            icon: current === type.mainColumnType ? getIcon("check") : "",
            action: () => {
              updatePage.optimistic({ id: pageId, main_column_type: type.mainColumnType });
              fitMainMonthColumnToType(ctx.api, pageId, updatePage, type.mainColumnType);
            },
          })),
        },
      ];
    }

    if (!ctx.isShadowCurve) return [];
    return [
      {
        name: "Column type",
        icon: getIcon("type"),
        subMenu: COLUMN_TYPE_OPTIONS.map((type) => ({
          name: type.label,
          action: () => update.optimistic({ id: ctx.columnId, column_type: type.columnType }),
        })),
      },
    ];
  };
};
